import React from 'react'
import { useIntl } from 'react-intl'
import { useData } from 'vike-react/useData'

import { useRoutes } from '../../routes'
import type { Data } from './+data'
import { HelpDoc } from './HelpDoc'
import { HelpShell } from './HelpShell'
import { HELP_CONTENT_WIDTH } from './helpTheme'

export default function HelpCenterPage() {
  const data = useData<Data>()
  const intl = useIntl()
  const routes = useRoutes()

  return (
    <HelpShell
      nav={{
        root: data.root,
        categories: data.categories,
        currentNoteId: data.currentNoteId,
        expandedIds: data.expandedIds,
      }}
      toc={data.headings}
      contentWidth={HELP_CONTENT_WIDTH}
      title={intl.formatMessage({
        id: 'website.helpCenter.helmet.title',
        defaultMessage: 'Slite Help Center',
      })}
      description={intl.formatMessage({
        id: 'website.helpCenter.helmet.description',
        defaultMessage:
          'Guides and answers to get the most out of Slite, from setting up your workspace to AI-powered search.',
      })}
      canonicalUrl={routes.helpCenter.index()}
    >
      <HelpDoc
        title={data.note.title}
        html={data.note.html}
        iconShape={data.note.iconShape}
        iconColor={data.note.iconColor}
      />
    </HelpShell>
  )
}
